<span class="goal-visibility-display-container">
  <span class="goal-visibility-icon" [tooltip]="visibilityTooltip | translate" [triggers]="globals.tooltipTriggers" placement="bottom" container="body">
    <span class="fal fa-fw" [ngClass]="visibilityIconClass"></span>
  </span>
</span>